module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.90eb440f.woff2";